import React from 'react';
import './PrivacyPolicy.css';  

const Loading = () => {
  return (
    <div className="container">
      <div className="loading-container">
        <div className="point point1"></div>
        <div className="point point2"></div>
        <div className="point point3"></div>
        <div className="point point4"></div>
        <div className="point point5"></div>
      </div>
    </div>
  );
};

export default Loading;
